import Tests from "./../../Components/Tests";
export default function DOC() {
  return (
    <>
      <Tests />
    </>
  );
}
